import AthleticTrainerModal from './AthleticTrainerModal'
export default AthleticTrainerModal